<template>
	<div>
		<h1>Ki- és belépések</h1>
    <v-tabs
      v-model="aktivtab"
      color="primary"
      icons-and-text
    >
      <v-tab>Kollégisták helye<v-icon>fa-map-marker</v-icon></v-tab>

      <v-tab-item>
        <v-data-table
          :headers="tablazatok.napiallapot.fejlec"
          :items="adatok.allapot.map(a => {
            return {
              nev: a.nev+' ('+adatok.minositesek.find(m =>m.id==a.minosites).minositesnev+')',
              csoport: a.csoport ? adatok.csoportok.find(cs => cs.id==a.csoport).csoportnev+' ('+adatok.csoportok.find(cs => cs.id==a.csoport).csoportvezetonev+')' : '-',
              szoba: a.szoba ? adatok.szobak.find(sz => sz.id==a.szoba).szobanev:'-',
              allapot: a.bent?'Bent':'Kint'
            }
            })"
          sort-by="nev"
          show-group-by
					v-if="adatok.allapot"
        >
        </v-data-table>
      </v-tab-item>
    </v-tabs>

	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
        aktivtab: 0,
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
        tablazatok: {
          napiallapot: {
            kereses: '',
            fejlec: [
              {
                text: "Tanuló",
                value: "nev",
                align: "center",
                sortable: true,
                filterable: true,
                groupable: false
              },
              {
                text: "Csoport",
                value: "csoport",
                align: "center",
                sortable: true,
                filterable: true,
                groupable: true
              },
              {
                text: "Szoba",
                value: "szoba",
                align: "center",
                sortable: true,
                filterable: true,
                groupable: true
              },
              {
                text: "Állapot",
                value: "allapot",
                align: "center",
                sortable: false,
                filterable: false,
                groupable: true
              }
            ]
          }
        },
        adatok: {}
      }
		},
		computed: {

		},
		watch: {

		},
		methods: {
      napiallapotfrissitese: function() {
        this.axios.get(this.$store.state.backendeleres+"kiesbelepesek/maiaktualis")
                  .then((response) => {
                    if(response.data.ejelentkezve==false) this.kijelentkezes();
                    if(response.data.ok) this.adatok=response.data.adatok;
                    else {
                      this.snackbar.szoveg=response.data.hiba;
                      this.snackbar.megnyit=false;
                    }
                  })
      }
		},
		mounted(){
      this.napiallapotfrissitese();
      setInterval(() => {this.napiallapotfrissitese()},60000);
    }
	}
</script>
